import { ReactNode, Suspense } from 'react';
import { MantineProvider } from './MantineProvider';
import { QueryProvider } from './QueryProvider';
import { DatesProvider } from './DatesProvider';
import { ContentProvider } from './ContentProvider';
import { Loading } from '@/components/ui/loading/Loading';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<MantineProvider>
			<QueryProvider>
				<ContentProvider>
					<DatesProvider>
						<Suspense fallback={<Loading />}>{children}</Suspense>
					</DatesProvider>
				</ContentProvider>
			</QueryProvider>
		</MantineProvider>
	);
};
